import { Component,Input, OnInit,AfterViewInit } from '@angular/core';
declare var $: any;
import { NgForm } from '@angular/forms';
import { commonService } from '../../service/common.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { userService } from '../../service/user.service';
import { FileSelectDirective,FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals } from '../../globals';
import { sessionService } from '../../service/session.service';
import { NgxPermissionsService } from "ngx-permissions";
import { TestSeriesService } from '../../service/test-series.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Component({
  selector: 'app-student-payment-form',
  templateUrl: './student-payment-form.component.html',
  styleUrls: ['./student-payment-form.component.css'],
  providers: [userService,Globals,sessionService,TestSeriesService]
})
export class StudentPaymentFormComponent implements OnInit,AfterViewInit {

  constructor(public http: HttpClient,private testseriesservice:TestSeriesService,private router:Router,private userservice:userService,private route: ActivatedRoute,private commonservice:commonService,private global: Globals, private _session:sessionService) {
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
   
  }

  form:any;
  msg="";
  msgclass="success";
  isError=false;
  profile:any;
  uploadData:any={};
  profileimage:any;
  isclickbuttonRegisterprofile = false;
  signatureImage:any={};
  identityImage:any={};
  attachmentUrl =this.global.siteUrl+'file/upload?folder='+this.global.profileFolder+'&mediaFor=userProfile';
  uploader:FileUploader=new FileUploader({url:this.attachmentUrl,authToken:sessionStorage.getItem('_to'),allowedMimeType: ['image/png','image/jpg','image/jpeg'],maxFileSize: 25*1024*1024});
  
  userData:any;
  isPostLoad=false;
  packageId:any;
  imgpath = this.global.profileUrl;
  ischosepayment=false;
  choseformvailidation=false;

  assignPaymentList:any;

  ischosePaymentId:any;
  checkedstatus:any;
  coursebox:any;
  Exambox:any;
  streambox:any;
  sessionbox:any;
  statebox:any;
  citybox:any;
  formvalidation=false;

  ismadeeasystudent=false;
  billlingAddId:any;
  packageamount:any;
  maxfilesize=25;
  filesizevalid=false;
  selectedFile=null;
  fileExtExists=false;
  minmobilenumber=false
  @Input() fileExt: string = "JPG, JPEG, PNG";
  emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  emailvailidation=false;
  targetFileUploaded:any;
  progress:any=0;

  ngOnInit() {
   // this.checkedstatus=1;
    this.getcourse('');
    this.getexamtype('');
    this.getstreamtype('');
    this.getsession('');

    this.getstate();
    
    this.profileimage={};this.uploadData={};this.signatureImage={};this.identityImage={};
   // console.log('fffff',this.profileimage.length);
  //  console.log('ddd',this.profileimage);
    this.commonservice.profile.subscribe((data:any)=>{
      if(data && Object.keys(data).length != 0){
      this.userData=data; 
      }else{
       this.userData={};
      }

    this.form={};
    // this.form.shwAttach = this.form.attachment=(Object.keys(this.userData).length>0 && (this.userData.photo!=null && this.userData.photo.length>0))? false : true;
    // this.form.shwsAttach = this.form.signatureAttachment=(Object.keys(this.userData).length>0 && (this.userData.signatureImage!=null && this.userData.signatureImage.length>0)) ? false : true;  
    // this.form.shwiAttach = this.form.identityAttachment=(Object.keys(this.userData).length>0 && (this.userData.identityImage!=null && this.userData.identityImage.length>0)) ? false : true;

     this.form.attachment=true;
     this.form.signatureAttachment=true;  
     this.form.identityAttachment=true;
   
     
   // this.creatPayment();

  //this.ischosepayment=true;
  //this.getPaymnetGateway();
   

  
    // check user photo,signatureImage and identityImage

    /*if(Object.keys(this.userData).length == 0){ 

     }else{

          if(this.userData.photo!="" && this.userData.signatureImage!="" && this.userData.identityImage!=""){
            this.ischosepayment=true;
          }
          else if(this.userData.photo!="" && this.userData.signatureImage!="" && this.userData.identityImage!="" && this.ischosePaymentId){
            this.isPostLoad=true;  
            //this.creatPayUPayment(); 
          }

     }
  */
  });
  }


getPaymnetGateway(){
  this.isPostLoad=true;
  //this.ischosepayment=true;
  this.route.params.subscribe((params: Params) => {
    if(params['id']){      
    this.packageId = parseInt(params['id']) ;
        if(this.packageId){
          this.getassignpaymetList(this.packageId);
        }
        if(isNaN(this.packageId)){
        // this.postId=0;
        } 
    }
  });
}
  creatPayUPayment(){
    this.userservice.creatPayment({user:this.userData,package:this.packageId,payment:this.ischosePaymentId,billaddressId:this.billlingAddId}).subscribe((data:any)=>{

      if(data.error==0){
      //console.log(data);
      window.location.href = data.payuurl;
       
     }else{
      this.getPaymnetGateway();
      this.msg=data.message;
      this.msgclass="danger";
       //alert(data.message);
     }
      //console.log(data.response);
    })

  }

  creatPaytmPayment(){
    this.userservice.creatPayment({user:this.userData,package:this.packageId,payment:this.ischosePaymentId,billaddressId:this.billlingAddId}).subscribe((data:any)=>{

      if(data.error==0){
     // console.log(data);
     // window.location.href = data.payuurl;
      window.location.href=this.global.siteUrl+'paytm/pay/'+data.txnId; 
      this.http.post
       
     }else{
      this.getPaymnetGateway();
      this.msg=data.message;
      this.msgclass="danger";
       //alert(data.message);
     }
      //console.log(data.response);
    })
    

  }

  private isValidFileSize(file) {
    var bytes=parseInt(file[0].size);
    var kbsize=Math.round(bytes/1048576);
   // console.log('file size calculated');
   // console.log(kbsize);
    if(kbsize <= this.maxfilesize){this.filesizevalid=false;}
    else{this.filesizevalid=true;}
    }
private isValidFileExtension(files){
      // Make array of file extensions
       var extensions = (this.fileExt.split(','))
                     .map(function (x) { return x.toLocaleUpperCase().trim() });
                     console.log(extensions+'test');
    //  // Get file extension
          var ext = files[0].name.toUpperCase().split('.').pop() || files[0].name;
         // console.log(ext+'test321');
          // Check the extension exists
          var exists = extensions.includes(ext);
          if(!exists){this.fileExtExists=true;}
          else{this.fileExtExists=false;}
        
      
    }
keyPress(event: any) {
      const pattern = /[0-9\+\-\ ]/;
     // console.log(event);
      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
       // console.log('not right');
      }
      else{
        if(event.key<=9){
          this.minmobilenumber=true;
         // console.log('not right');
        }
        else{
          this.minmobilenumber=false;
         // console.log('right');
        }
      }
    }

  updatePayment(paymentform){

   // console.log(this.assignPaymentList.paymentCompany.paymnetCompanyAssigns);

    if(paymentform.status=="INVALID"){
      this.choseformvailidation=true;
    }
    else{
      this.choseformvailidation=false;
     // this.ischosePaymentId=this.checkedstatus;      
      this.isPostLoad=true; 
      for(let key in this.assignPaymentList.paymentCompany.paymnetCompanyAssigns){
          this.ischosePaymentId = this.assignPaymentList.paymentCompany.paymnetCompanyAssigns[key].id;
          if(this.assignPaymentList.paymentCompany.paymnetCompanyAssigns[key].paymentGateway.paymetType=="payu"){
          this.creatPayUPayment();
          }else{
          this.creatPaytmPayment(); 
          }         
      }

 
/*console.log(this.ischosePaymentId);  return false;
    switch (this.ischosePaymentId) {
      case "1":
       this.creatPayUPayment(); 
        break;
      case "2":
      this.creatPaytmPayment(); 
        break;
     
    }*/
      
    }
    

  }

  getassignpaymetList(Id){ 
    this.testseriesservice.getassignpaymetList(Id).subscribe((data : any)=>{ 

   /// console.log(data);     
      if(data.error==0){ 
        this.isPostLoad=false;
       // console.log('payment list',data);
        this.assignPaymentList = data.results;
        if(this.ismadeeasystudent){
          //console.log("enrollstudent");
          this.packageamount=(this.assignPaymentList.totalintPriceAmt>0)?this.assignPaymentList.totalintPriceAmt:this.assignPaymentList.totalpriceAmt;
        }else{
         // console.log("gusetstudent");
          this.packageamount=(this.assignPaymentList.totalintPriceAmt>0)?this.assignPaymentList.totalextPriceAmt:this.assignPaymentList.totalpriceAmt;
        }
      }else{
        if(data.message=="Failed to authenticate token."){
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        }else{
         this.msg = data.message;
         this.isError = true;
        }
      }
  },
  (error : HttpErrorResponse)=>{
   this.isError = true;
   this.msg="internal server error!";
  });  
  
  }

  backtostep(){
    this.ischosepayment=false;
  }

  updateProfile(profiledata:NgForm){
    
    if(profiledata.status=='INVALID'){
      //console.log('invalid status');
      this.formvalidation=true;
      
      this.emailvailidation=(profiledata.value.email.match(this.emailPattern))?(false):(true);
    }
    else{
      console.log('good');
      
      
      this.formvalidation=false;
      this.isclickbuttonRegisterprofile=true;

    this.form.attachmenterror="";
    this.form.signatureAttachmenterror="";
    this.form.identityAttachmenterror="";

    let user={}
    for(var i in profiledata.value){
      user[i]=profiledata.value[i];
      this.form[i]=profiledata.value[i]

    }
   // console.log();
   // user['userType']=this.userData.userType;
    user['userId']=this.userData.id;
    user['profileImage']=this.profileimage.uploadname;
    user['signatureImage']=this.signatureImage.uploadname;
    user['identityImage']=this.identityImage.uploadname;
    
  //  console.log('update',profiledata);
    if(this.form.identityAttachment==false && this.form.identityAttachment==false && this.form.identityAttachment==false){

      this.testseriesservice.addstudentbillinfo(user).subscribe((data:any)=>{
          if(data.error==0){
            this.isclickbuttonRegisterprofile=false;
            this.billlingAddId=data.results;
            this.ischosepayment=true;
            

            this.uploader.queue=[];
            this.getPaymnetGateway();
            //this.msg="Profile has been saved successfully";
          //  this.router.navigateByUrl('user/student-form-pre-payment');
            
          }
      },(error : HttpErrorResponse)=>{      
        this.msg="internal server error!";
        this.msgclass="danger";
      });  

    }else{
      if(this.form.attachment){
        this.form.attachmenterror="Please choose profle image";
      }

      if(this.form.signatureAttachment){
        this.form.signatureAttachmenterror="Please choose Signature image";

      }
      if(this.form.identityAttachment){
        this.form.identityAttachmenterror="Confirm choose ID Proof image";
      }
      this.isclickbuttonRegisterprofile=false;
    } 

  }
    
  }

  ngAfterViewInit() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
   });
  }

  onFileChanged(event) {
    
    //this.uploader.uploadAll();
    // if(event.target.id=='attachment') {
    //   this.validateFileSize(event,250,250);
    // }
    // if(event.target.id=='signatureAttachment'){
    //    this.validateFileSize(event,350,100);
    // }
    // if(event.target.id=='identityAttachment') {
      
    //   this.validateFileSize(event,250,250);
    // }
    this.targetFileUploaded = event.target;
    this.selectedFile = event.target.files
    //console.log(this.isValidFileExtension(this.selectedFile));
   // console.log(this.selectedFile);
 //   this.isValidFileExtension(this.selectedFile);
    //this.isValidFileSize(this.selectedFile);


    if(this.fileExtExists==false && this.filesizevalid==false){

          this.msg="";
          this.uploadData={};
          this.uploader.queue[0].upload();
          this.progress=1;
          
              //this.sleep(2000).then(() => {
              
            //   console.log('test123');
             // })
      
    }
    

     
   }
   
   private sleep (time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  validateFileSize(event,w,h){

    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      const img = new Image();
      img.src = window.URL.createObjectURL( file );

      reader.readAsDataURL(file);
      reader.onload = () => {

        const width = img.naturalWidth;
        const height = img.naturalHeight;

        if(width<w || height<h){
          this.isError = true;
          this.msg = "Image size didn't match! Please use below described size. ";
          this.msgclass="danger";
          this.uploader.queue=[];
        }else{
          this.isError = false;
          this.msg="";
            this.uploadData={};
            this.uploader.queue[0].upload();
            this.progress=1;
            
            this.sleep(2000).then(() => {
              if(this.uploader.queue[0].isSuccess){
                if(event.target.id=='signatureAttachment'){
                  this.form.signatureAttachment=false; 
                  this.signatureImage =  this.uploadData;
                }else if(event.target.id=='attachment'){
                  this.form.attachment = false;
                  this.profileimage =  this.uploadData;
                }else if(event.target.id=='identityAttachment'){
                  this.form.identityAttachment=false;
                  this.identityImage =  this.uploadData;
                }
              }
              this.uploader.queue=[];
           //   console.log('test123');
            })
          
        }
        
    };
   }
  }

  closenotification(variable){
    this[variable]="";
   }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response); //success server response
   
      if(data.error==0){
        this.progress=0;
        this.uploadData=data.result.mediaDetail;      
        
        
        if(this.uploader.queue[0].isSuccess){
          if(this.targetFileUploaded.id=='signatureAttachment'){
            this.form.signatureAttachment=false; 
            this.signatureImage =  this.uploadData;
          }else if(this.targetFileUploaded.id=='attachment'){
            this.form.attachment = false;
            this.profileimage =  this.uploadData;
          }else if(this.targetFileUploaded.id=='identityAttachment'){
            this.form.identityAttachment=false;
            this.identityImage =  this.uploadData;
          }
        }
        this.uploader.queue=[];


      }       
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
      let error = JSON.parse(response); //error server response
       }

       onradioselect(radioId){
        // console.log(radioId);
       
        this.checkedstatus=radioId;
       

       }



getcourse(courseId){
        this._session.usercourse(courseId).subscribe((data : any)=>{     
          if(data.error==0){ 
            this.coursebox = data.results;
            console.log(this.coursebox);   
          }else{
            if(data.message=="Failed to authenticate token."){
              sessionStorage.clear();
              localStorage.clear();
              this.router.navigate(['/admin']);
            }else{
             this.msg = data.message;
             this.isError = true;
            }
          }
      },
      (error : HttpErrorResponse)=>{
       this.isError = true;
       this.msg="internal server error!";
      });    
      }
      
    
      
      getexamtype(examtypeId){
        this._session.userExam(examtypeId).subscribe((data : any)=>{     
          if(data.error==0){ 
            this.Exambox = data.results;   
          }else{
            if(data.message=="Failed to authenticate token."){
              sessionStorage.clear();
              localStorage.clear();
              this.router.navigate(['/admin']);
            }else{
             this.msg = data.message;
             this.isError = true;
            }
          }
      },
      (error : HttpErrorResponse)=>{
       this.isError = true;
       this.msg="internal server error!";
      });    
      }
      
      
      getstreamtype(streamtypeId){
        this._session.userstream(streamtypeId).subscribe((data : any)=>{     
          if(data.error==0){ 
            this.streambox= data.results;   
          }else{
            if(data.message=="Failed to authenticate token."){
              sessionStorage.clear();
              localStorage.clear();
              this.router.navigate(['/admin']);
            }else{
             this.msg = data.message;
             this.isError = true;
            }
          }
      },
      (error : HttpErrorResponse)=>{
       this.isError = true;
       this.msg="internal server error!";
      });    
      }
      getsession(sessionId){
        this._session.usersession(sessionId).subscribe((data : any)=>{
                if(data.error==0){ 
                  this.sessionbox = data.results;   
                }else{
                  if(data.message=="Failed to authenticate token."){
                    this.router.navigate(['/admin']);
                  }else{
                   this.msg = data.message;
                   this.isError = true;
                  }
                }
         },
           (error : HttpErrorResponse)=>{
             this.isError = true;
             this.msg="internal server error!";
           });
      
    }


    getstate(){
      this._session.userstate().subscribe((data : any)=>{
              if(data.error==0){ 
                this.statebox = data.results;   
              }else{
                if(data.message=="Failed to authenticate token."){
                  this.router.navigate(['/admin']);
                }else{
                  this.msg = data.message;
                  this.isError = true;
                }
              }
        },
          (error : HttpErrorResponse)=>{
            this.isError = true;
            this.msg="internal server error!";
          });
    
    }
  
    onChangeState($event,stateValue){
      //console.log(stateValue);
      //console.log('yeestateid');
        this._session.usercity(stateValue).subscribe((data : any)=>{
                
          if(data.error==0){ 
            
            this.citybox = data.results;
                
          }else{
            if(data.message=="Failed to authenticate token."){
              //sessionStorage.clear();
              //localStorage.clear();
              this.router.navigate(['/admin']);
            }else{
              this.msg = data.message;
              this.isError = true;
            }
      
          }
      },
      (error : HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
      });
          
      }

      onismadeeasy(value){
        //console.log('11111111111>>>>>>>')
            //console.log(value);
            this.ismadeeasystudent=(value=='yes')?(true):false;
           // console.log(this.ismadeeasystudent);
            
      }

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/student-payment-form/student-payment-form.component.ts